import { useMutation } from "@tanstack/react-query";
import { Change } from "../interfaces/Change";
import axios, { AxiosError } from "axios";
import { links } from "../../utils/links";
import { getJWT } from "../../utils/storageService";
import { enqueueSnackbar } from "notistack";

export interface ErrorResponse {
    status: string;
    message: string;
    time: string;
}


const usePostChangeQuery = () => {

    const jwt = getJWT();

    return useMutation({
        mutationKey: ['Changes', 'New'],
        mutationFn: (change: Change) => axios
            .post(links.postAenderungen, change, { headers: { Authorization: `Bearer ${jwt}` } })
            .then(res => res.data),
        onSuccess: change => enqueueSnackbar('Ihre Änderung wird verarbeitet: ' + change.feld, { variant: "success" }),
        onError: (e) => {
            const error = e as AxiosError;
            const errorData = error?.response?.data as ErrorResponse;
            const errorMessage = errorData?.message || 'Unknown error';
            enqueueSnackbar(`Ein Fehler ist aufgetreten: ${errorMessage}`, { variant: "error" });
        }
    })
}

export default usePostChangeQuery;